import { render, staticRenderFns } from "./RemoveDateModal.vue?vue&type=template&id=18c857e1&scoped=true&"
import script from "./RemoveDateModal.vue?vue&type=script&lang=js&"
export * from "./RemoveDateModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveDateModal.vue?vue&type=style&index=0&id=18c857e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c857e1",
  null
  
)

export default component.exports